export default __webpack_public_path__ + "static/media/6.7c15aa8f.jpg";